﻿/**
 * app
 * @namespace portal
 */

(function () {
	'use strict';

	/** create the nha.portal module */
	angular.module('nha.portal', _ng.moduleInit(['nha.core']));
})();